export default __webpack_public_path__ + "static/media/060_corner2.last.52c0c6b1.avif";